const prefix = 'PAYMENT_ARRANGEMENT'

export const ARRANGE_PAYMENT = `${prefix}/ARRANGE_PAYMENT`